import { render } from "./loading-screen.vue?vue&type=template&id=7ed0f48a"
import script from "./loading-screen.vue?vue&type=script&lang=js"
export * from "./loading-screen.vue?vue&type=script&lang=js"

import "./loading-screen.vue?vue&type=style&index=0&id=7ed0f48a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__